export default __webpack_public_path__ + "static/media/ad_300x250_install_en@2x.7ebdbed2.png";